import { apiUrlBff } from "@settings";

import { getBaseAxiosInstance } from "./base";

const BASE_URL = apiUrlBff;

export default getBaseAxiosInstance(BASE_URL, { isBff: true });
